export default "__VITE_ASSET__7356a00d__"